import React from "react";
import styled from "styled-components";

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 500;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: stretch;
  justify-content: center;
`;

const Panel = styled.div`
  width: 100%;
  max-width: 480px;
  background: #fff;
  display: flex;
  flex-direction: column;
  min-height: 100%;
`;

const Head = styled.div`
  padding: 16px;
  border-bottom: 1px solid #eee;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: max(16px, env(safe-area-inset-top));
`;

const Title = styled.h2`
  margin: 0;
  font-size: 16px;
  font-weight: 800;
`;

const Back = styled.button`
  border: none;
  background: #f5f5f5;
  padding: 8px 12px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 700;
`;

const Body = styled.div`
  padding: 16px;
  flex: 1;
  overflow-y: auto;
  font-size: 14px;
  color: #616161;
  line-height: 1.5;
`;

interface ComparePlansModalProps {
  open: boolean;
  title?: string;
  onClose: () => void;
}

/** Placeholder full-screen shell; host apps can swap in a full compare table. */
export const ComparePlansModal = ({
  open,
  title = "Compare plans",
  onClose,
}: ComparePlansModalProps) => {
  if (!open) return null;

  return (
    <Overlay role="presentation">
      <Panel role="dialog" aria-modal aria-labelledby="compare-title">
        <Head>
          <Back type="button" onClick={onClose}>
            Back
          </Back>
          <Title id="compare-title">{title}</Title>
          <span style={{ width: 56 }} />
        </Head>
        <Body>
          Full compare table and filters are provided by the native app. Wire
          this modal to your compare API when ready.
        </Body>
      </Panel>
    </Overlay>
  );
};
